import React from "react";
import "./About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf, faLightbulb, faHandHoldingHeart, faDraftingCompass } from "@fortawesome/free-solid-svg-icons";

const About = () => {
  return (
    <section id="about" className="about-section" style={{ backgroundImage: `url(/img/architecture-background.jpg)` }}>
      <div className="about-overlay">
        <div className="about-content">
          {/* Sobre Nosotros */}
          <div className="about-block">
            <h2>SOBRE NOSOTROS</h2>
            <p>
              Somos una empresa fundada el <strong>14 de noviembre del 2024</strong>, con la misión de brindar servicios de construcción de alta calidad. Nos comprometemos a satisfacer las necesidades de nuestros clientes, respetando el medio ambiente y utilizando prácticas sostenibles e innovadoras.
            </p>
          </div>

          {/* Misión y Visión en columnas */}
          <div className="about-row">
            <div className="about-block left-column">
              <h2>MISIÓN</h2>
              <p>
                Garantizar calidad y profesionalismo en todos nuestros servicios. Nos esforzamos por cumplir los más altos estándares normativos y de calidad, mientras fomentamos el desarrollo personal y profesional de nuestro equipo.
              </p>
            </div>
            <div className="about-block left-column">
              <h2>VISIÓN</h2>
              <p>
                Ser una empresa líder y referente en el sector, eficiente, responsable y comprometida. Nuestro objetivo es gestionar la complejidad de cada proyecto atendiendo los aspectos normativos, económicos y sociales de forma integral.
              </p>
            </div>
          </div>

          {/* Valores */}
          <div className="about-block">
            <h2>VALORES</h2>
            <div className="values-columns">
              <div className="column">
                <ul className="values-list">
                  <li>
                    <FontAwesomeIcon icon={faHandHoldingHeart} className="icon" />
                    <b>Responsabilidad:</b> Compromiso total con la satisfacción del cliente y adaptación a sus necesidades.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faLightbulb} className="icon" />
                    <b>Innovación:</b> Aprovechamos las herramientas tecnológicas para mejorar continuamente.
                  </li>
                </ul>
              </div>
              <div className="column">
                <ul className="values-list">
                  <li>
                    <FontAwesomeIcon icon={faLeaf} className="icon" />
                    <b>Sostenibilidad:</b> Respetamos el medio ambiente y promovemos prácticas responsables.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faDraftingCompass} className="icon" />
                    <b>Diseño:</b> Nos enfocamos en el rigor del trabajo bien hecho, manteniendo un compromiso cultural y social.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
